export default __webpack_public_path__ + "static/media/carbon-logout.cb1ff83d.svg";